import React from "react";
import { CompanyEventTotalsBlock } from "./CompanyEventTotalsBlock";
import { CompanyConsumablesCalculator } from "./CompanyConsumablesCalculator";
import { useCompanyPrintLabelStatsContext } from "./CompanyPrintLabelStatsContext";

export function CompanyEventTotalsSection({ companyId }) {
  const { canView } = useCompanyPrintLabelStatsContext();

  if (!canView) {
    return <CompanyEventTotalsBlock companyId={companyId} />;
  }

  return (
    <div className="info-stack event-totals-calculator-stack">
      <CompanyEventTotalsBlock companyId={companyId} />
      <CompanyConsumablesCalculator companyId={companyId} />
    </div>
  );
}
